export default {
  "content": "<circle cx=\"8\" cy=\"8\" r=\"7\" stroke=\"#ff00cb\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"/><path d=\"M6.586 5.172a1 1 0 00-1.414 1.414zm2.828 5.656a1 1 0 101.414-1.414zm1.414-4.242a1 1 0 00-1.414-1.414zM5.172 9.414a1 1 0 101.414 1.414zm0-2.828l4.242 4.242 1.414-1.414-4.242-4.242zm4.242-1.414L5.172 9.414l1.414 1.414 4.242-4.242z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "fill": "none",
    "height": "16",
    "width": "16",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};